:host {
    @include flex-row(stretch, stretch);
    position: relative;
    width: 100%;
    height: 100%;
    background: #131313;
    color: #ffd;
}

aside {
    @include flex-col(stretch, stretch);
    width: 512px;
    height: 100%;
    padding: 8px;
    overflow-x: hidden;
    overflow-y: auto;
}

select {
    max-width: 100px;
    background: transparent;
    color: #fff;

    & > option {
        background: #212021;
        color: #fff;
    }
}
